import React from 'react';
import type { FormFieldProps } from 'semantic-ui-react';
import { SchemaTypes } from '@axiom/types';

import { FormField } from '../FormField/FormField';

import type {
  RawSortableListProps,
  RawSortableValueType,
} from './RawSortableList';
import { RawSortableList } from './RawSortableList';

export type SortableListProps = {
  description?: string;
  dismissible?: RawSortableListProps['dismissible'];
  dismissibleIcon?: RawSortableListProps['dismissibleIcon'];
  emptyComponent?: RawSortableListProps['emptyComponent'];
  id?: RawSortableListProps['id'];
  label?: React.ReactNode;
  name: RawSortableListProps['name'];
  onAfterRemove?: RawSortableListProps['onAfterRemove'];
  hideHandle?: RawSortableListProps['hideHandle'];
  showDropPlaceholder?: RawSortableListProps['showDropPlaceholder'];
};
export const SortableList = ({
  description,
  dismissible = false,
  dismissibleIcon = 'trash',
  emptyComponent,
  id,
  label,
  name,
  onAfterRemove,
  hideHandle = false,
  showDropPlaceholder = false,
}: SortableListProps) => {
  const effectiveId = id || name;

  return (
    <FormField
      {...{
        description,
        id: effectiveId,
        name,
        label,
      }}
      renderField={({
        setFieldValue,
        schemaProperty,
        value,
      }: FormFieldProps & {
        value: RawSortableValueType | undefined | null;
      }) => {
        if (schemaProperty.type !== SchemaTypes.ZodArray) {
          throw new Error(`Options for '${name}' must be an array of values`);
        }
        if (!value) {
          throw new Error(
            `Must provide initial values for '${name}' which correspond to an array of valueKey values from options objects`
          );
        }
        return (
          <RawSortableList
            dismissible={dismissible}
            dismissibleIcon={dismissibleIcon}
            emptyComponent={emptyComponent}
            id={effectiveId}
            name={name}
            onAfterRemove={(removedItem, updatedList) => {
              onAfterRemove?.(removedItem, updatedList);
              setFieldValue(name, updatedList);
            }}
            value={value}
            hideHandle={hideHandle}
            showDropPlaceholder={showDropPlaceholder}
          />
        );
      }}
    />
  );
};
